<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li *ngFor="let route of routes">
                    <a routerLink="{{route.url}}">{{route.label}}</a>
                </li>
            </ul>
            <h2>Modificar Afiliado</h2>
        </div>
    </div>
</div>

<app-loading *ngIf="!flagLoaded" class="m-5"></app-loading>

<div class="andorra-apply-content ptb-70 animate__animated animate__fadeIn">
    <div class="container" *ngIf="flagLoaded">
        <div class="profile-courses-quizzes">
            <div class="row">
                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="apply-form">
                        
                        <!-- CABECERA UNIFICADA -->
                        <div class="usuario-header">
                            <div class="usuario-info">
                                <h3 class="usuario-nombre" *ngIf="usuario">
                                    {{usuario?.nombrePersona}} {{usuario?.apellidoPersona}}
                                </h3>
                                <button (click)="mostrarDatosGecros()" class="btn-gecros">
                                    {{mostrarCard ? 'Ocultar' : 'Mostrar'}} Datos Gecros
                                </button>
                            </div>
                            <mat-progress-bar *ngIf='flagProcesando' mode="indeterminate"></mat-progress-bar>
                        </div>

                        <!-- DATOS GECROS -->
                        <div *ngIf="mostrarCard" class="gecros-card">
                            <div class="card">
                                <div class="card-header">DATOS GECROS</div>
                                <div class="card-body">
                                    <ul>
                                        <li><strong>ID:</strong> {{ usuario.signoGecrosAfiliado._id }}</li>
                                        <li><strong>Nombre Afiliado:</strong> {{ usuario.signoGecrosAfiliado.nombreAfiliado }}</li>
                                        <li><strong>CUIL:</strong> {{ usuario.signoGecrosAfiliado.cuil }}</li>
                                        <li><strong>Número de Afiliado:</strong> {{ usuario.signoGecrosAfiliado.numeroAfiliado }}</li>
                                        <li><strong>Sexo:</strong> {{ usuario.signoGecrosAfiliado.sexo }}</li>
                                        <li><strong>Estado:</strong> {{ usuario.signoGecrosAfiliado.estado }}</li>
                                        <li><strong>Convenio:</strong> {{ usuario.signoGecrosAfiliado.convenio }}</li>
                                        <li><strong>Plan:</strong> {{ usuario.signoGecrosAfiliado.plan }}</li>
                                        <li><strong>Fecha de Nacimiento:</strong> {{ usuario.signoGecrosAfiliado.fechaNacimiento }}</li>
                                        <li><strong>Legajo:</strong> {{ usuario.signoGecrosAfiliado.legajo }}</li>
                                        <li><strong>Email:</strong> {{ usuario.signoGecrosAfiliado.email }}</li>
                                        <li><strong>Agente Cuenta:</strong> {{ usuario.signoGecrosAfiliado.agenteCuenta }}</li>
                                        <li><strong>Parentesco:</strong> {{ usuario.signoGecrosAfiliado.parentesco }}</li>
                                        <li><strong>Observaciones:</strong> {{ usuario.signoGecrosAfiliado.observaciones }}</li>
                                        <li><strong>Medico Cabecera:</strong> {{ usuario.signoGecrosAfiliado.medicoCabecera }}</li>
                                        <li><strong>Coberturas:</strong> {{ usuario.signoGecrosAfiliado.coberturas }}</li>
                                        <li><strong>Created At:</strong> {{ usuario.signoGecrosAfiliado.createdAt }}</li>
                                        <li><strong>Updated At:</strong> {{ usuario.signoGecrosAfiliado.updatedAt }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <!-- PESTAÑAS -->
                        <div class="tabs-container">
                            <div class="tabs-header">
                                <div class="tab" 
                                     [class.active]="tabActiva === 'informacion'"
                                     (click)="cambiarTab('informacion')">
                                    Información Básica
                                </div>
                                <div class="tab"
                                     [class.active]="tabActiva === 'grupo-familiar'"
                                     (click)="cambiarTab('grupo-familiar')">
                                    Grupo Familiar
                                </div>
                                <div class="tab"
                                     [class.active]="tabActiva === 'gestion'"
                                     (click)="cambiarTab('gestion')">
                                    Gestión
                                </div>
                                <div class="tab"
                                     [class.active]="tabActiva === 'tramites'"
                                     (click)="cambiarTab('tramites')">
                                    Trámites
                                </div>
                            </div>

                            <div class="tabs-content">
                                <!-- PESTAÑA INFORMACIÓN BÁSICA -->
                                <div class="tab-pane" *ngIf="tabActiva === 'informacion'">
                                    <form [formGroup]="formAfiliado" (ngSubmit)="onSubmit()">
                                        <div class="form-grid">
                                            <!-- PRIMERA FILA - DATOS PERSONALES BÁSICOS -->
                                            <div class="form-section">
                                                <h4 class="section-title">Datos Personales</h4>
                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Nombre</mat-label>
                                                            <input matInput formControlName="nombre" 
                                                                placeholder="Escriba su nombre completo"
                                                                class="uppercase"
                                                                [class.is-invalid]="nombre" required>
                                                            <mat-error *ngIf="nombre">Ingrese un nombre</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Apellido</mat-label>
                                                            <input matInput formControlName="apellido" 
                                                                placeholder="Escriba su apellido completo"
                                                                class="uppercase"
                                                                [class.is-invalid]="apellido" required>
                                                            <mat-error *ngIf="apellido">Ingrese un apellido</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Tipo de identificación</mat-label>
                                                            <mat-select formControlName="tipoIdentificacion"
                                                                        (selectionChange)="onChangeTipoIdentificacion($event.value);">
                                                                <mat-option *ngFor="let ti of tiposIdentificaciones"
                                                                            [value]="ti.concepto">
                                                                    {{ti.concepto}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="tipoIdentificacion">Ingrese un tipo de identificación</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Número de identificación - D.N.I</mat-label>
                                                            <input matInput formControlName="identificacion" 
                                                                placeholder="Escriba su número de identificación"
                                                                [class.is-invalid]="identificacion">
                                                            <mat-error *ngIf="identificacion">Ingrese una identificación</mat-error>
                                                        </mat-form-field>
                                                        <div *ngIf="this.flagExisteIdentificacion" class="identification-warning">
                                                            <mat-error>Su identificación ya existe en el sistema</mat-error>
                                                            <div class="warning-message">
                                                                Su identificación tiene asociada otra cuenta de email. Debe ponerse en contacto con el administrador del sistema, para poder validar su identidad y continuar la solicitud
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- SEGUNDA FILA - DATOS DE NACIMIENTO Y CONTACTO -->
                                            <div class="form-section">
                                                <h4 class="section-title">Datos de Nacimiento y Contacto</h4>
                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Fecha de nacimiento</mat-label>
                                                            <input matInput formControlName="birth" [matDatepicker]="birthPicker">
                                                            <mat-datepicker-toggle matSuffix [for]="birthPicker"></mat-datepicker-toggle>
                                                            <mat-datepicker #birthPicker></mat-datepicker>
                                                            <mat-error *ngIf="birth">Ingrese la fecha de nacimiento</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>País de nacimiento</mat-label>
                                                            <input matInput formControlName="paisNacimiento"
                                                                (ngModelChange)="onChangePais($event)"
                                                                list="paises"
                                                                placeholder="Escriba aquí para buscar..."
                                                                [class.is-invalid]="paisNacimiento">
                                                            <mat-error *ngIf="paisNacimiento">Ingrese un pais de nacimiento</mat-error>
                                                        </mat-form-field>
                                                        <datalist id="paises">
                                                            <option *ngFor="let pais of paises" [value]="pais.name_es">
                                                                {{pais.name_es}}
                                                            </option>
                                                        </datalist>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Estado Civil</mat-label>
                                                            <mat-select formControlName="estadoCivil"
                                                                        (selectionChange)="onChangeEstadoCivil($event.value)">
                                                                <mat-option *ngFor="let estadoCivil of estadosCiviles"
                                                                            [value]="estadoCivil.concepto">
                                                                    {{estadoCivil.concepto}}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="estadoCivil">Seleccione el estado civil</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Código de área</mat-label>
                                                            <input matInput formControlName="paisCodeArea"
                                                                placeholder="Escriba el código de área"
                                                                [class.is-invalid]="paisCodeArea">
                                                            <mat-error *ngIf="paisCodeArea">Ingrese un código de área</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Número de teléfono</mat-label>
                                                            <input matInput formControlName="telefono" 
                                                                placeholder="Escriba el número de teléfono"
                                                                [class.is-invalid]="telefono">
                                                            <mat-error *ngIf="telefono">Ingrese un número de telefono</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- TERCERA FILA - DATOS INSTITUCIONALES -->
                                            <div class="form-section">
                                                <h4 class="section-title">Datos Institucionales</h4>
                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Plan</mat-label>
                                                            <mat-select formControlName="signoPlan"
                                                                        [disabled]="!planes">
                                                                <mat-option *ngFor="let plan of planes"
                                                                            [value]="plan._id">
                                                                    {{ plan.denominacion }}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="plan">Seleccione un plan</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Sede</mat-label>
                                                            <mat-select formControlName="signoSedes"
                                                                        [disabled]="!sedes"
                                                                        required>
                                                                <mat-option *ngFor="let sede of sedes"
                                                                            [value]="sede._id">
                                                                    {{ sede.nombre }}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="sede">Seleccione una sede</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Empresa</mat-label>
                                                            <mat-select formControlName="signoEmpresas"
                                                                        [disabled]="!empresas">
                                                                <mat-option *ngFor="let empresa of empresas"
                                                                            [value]="empresa._id">
                                                                    {{ empresa.nombre }}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="empresa">Seleccione una empresa</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                                <button mat-raised-button 
                                                        color="primary" 
                                                        class="btn-sincronizar-gecros"
                                                        type="button"
                                                        (click)="sincronizarInstitucionalesGecros()"
                                                        [disabled]="!gecrosData || isLoading">
                                                    <mat-icon>sync</mat-icon> 
                                                    Sincronizar con Gecros
                                                </button>
                                            </div>
                                        </div>

                                        <div class="form-actions">
                                            <div *ngIf="!formAfiliado.valid" style="color: #d32f2f; font-size: 12px; margin-bottom: 10px; font-weight: bold;">
                                                Faltan campos: 
                                                <span *ngIf="formAfiliado.get('nombre').invalid">Nombre, </span>
                                                <span *ngIf="formAfiliado.get('apellido').invalid">Apellido, </span>
                                                <span *ngIf="formAfiliado.get('tipoIdentificacion').invalid">Tipo ID, </span>
                                                <span *ngIf="formAfiliado.get('identificacion').invalid">ID, </span>
                                                <span *ngIf="formAfiliado.get('signoSedes').invalid">Sede, </span>
                                                <span *ngIf="formAfiliado.get('signoPlan').invalid">Plan, </span>
                                                <span *ngIf="formAfiliado.get('birth').invalid">Fecha Nac., </span>
                                            </div>
                                            <button routerLink="/afiliados-listado" class="btn-cancelar">CANCELAR</button>
                                            <button [disabled]="!formAfiliado.valid"
                                                    [ngClass]="{'custom-disabled': !formAfiliado.valid}"
                                                    type="submit" class="btn-guardar">GUARDAR</button>
                                        </div>
                                    </form>
                                </div>

                                <!-- PESTAÑA GRUPO FAMILIAR -->
                                <div class="tab-pane" *ngIf="tabActiva === 'grupo-familiar'">
                                    <div class="form-grid">
                                        <!-- SECCIÓN GRUPO FAMILIAR -->
                                        <div class="form-section">
                                            <div class="section-header">
                                                <h4 class="section-title">Grupo Familiar</h4>
                                                <div class="section-actions">
                                                    <button mat-raised-button color="primary" class="btn-nuevo-familiar" (click)="abrirModalNuevoFamiliar()">
                                                        <mat-icon>add</mat-icon> 
                                                        Nuevo Familiar
                                                    </button>
                                                </div>
                                            </div>

                                            <app-loading *ngIf="flagCargandoGrupoFamiliar" class="m-5"></app-loading>

                                            <div *ngIf="!flagCargandoGrupoFamiliar">
                                                <div class="table-section" *ngIf="flagGrupoFamiliar">
                                                    <div class="table-container">
                                                        <table mat-table [dataSource]="dataSource" matSort class="material-table">
                                                            <ng-container matColumnDef="nombre">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Nombre y Apellido</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.nombrePersona+ ' ' +element?.apellidoPersona}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="identificacion">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Documento</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.identificacion}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="domicilio">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Domicilio</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{ formatDomicilio(element?.signoGecrosAfiliado.domicilios[0].calle, element?.signoGecrosAfiliado.domicilios[0].numero) }}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="email">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Email</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.email}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="sede">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Sede</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.signoSedes[0].nombre}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="plan">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Plan</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.signoPlan}}
                                                                </td>
                                                            </ng-container>

                                                            <ng-container matColumnDef="empresa">
                                                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                                                    <div class="table-header">Empresa</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell">
                                                                    {{element?.signoEmpresas[0].nombre}}
                                                                </td>
                                                            </ng-container>
                                                            
                                                            <ng-container matColumnDef="acciones">
                                                                <th mat-header-cell *matHeaderCellDef>
                                                                    <div class="table-header">Acciones</div>
                                                                </th>
                                                                <td mat-cell *matCellDef="let element" class="table-cell acciones-cell">
                                                                    <button mat-icon-button color="warn" 
                                                                            (click)="eliminarFamiliar(element._id)" 
                                                                            title="Eliminar familiar"
                                                                            class="btn-eliminar">
                                                                        <mat-icon>delete</mat-icon>
                                                                    </button>
                                                                </td>
                                                            </ng-container>

                                                            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="table-header-row"></tr>
                                                            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="table-row"></tr>
                                                        </table>

                                                        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" 
                                                                    class="custom-paginator"></mat-paginator>
                                                    </div>
                                                </div>

                                                <div *ngIf="!flagGrupoFamiliar" class="no-data-section">
                                                    <div class="no-data-message">
                                                        <mat-icon>group_off</mat-icon>
                                                        <h4>No se encontraron familiares</h4>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- PESTAÑA GESTIÓN -->
                                <div class="tab-pane" *ngIf="tabActiva === 'gestion'">
                                    <form [formGroup]="formAfiliado" (ngSubmit)="onSubmit()">
                                        <div class="form-grid">
                                            <!-- ALERTA INFORMATIVA -->
                                            <div class="alert-section">
                                                <div class="alert alert-info">
                                                    <strong>¡Información!</strong> Si el usuario al que se
                                                    le cambia de <strong>Estado</strong> es titular, se le
                                                    cambiara el mismo a sus familiares. En el caso de
                                                    <u>suspensión</u>, si un familiar posee alguna clausula,
                                                    quedará excluido.
                                                </div>
                                            </div>

                                            <!-- SECCIÓN ESTADO Y FECHAS PRINCIPALES -->
                                            <div class="form-section">
                                                <h4 class="section-title">Estado y Fechas Principales</h4>
                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Estado</mat-label>
                                                            <mat-select formControlName="estado">
                                                                <mat-option *ngFor="let estado of estados" [value]="estado">
                                                                    {{ estado }}
                                                                </mat-option>
                                                            </mat-select>
                                                            <mat-error *ngIf="estado">Seleccione un estado</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Fecha de Vigencia</mat-label>
                                                            <input matInput formControlName="fechaVigencia" [matDatepicker]="picker1">
                                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker1></mat-datepicker>
                                                            <mat-error *ngIf="fechaVigenciaNoValida">Ingrese una fecha</mat-error>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Fecha de Cobertura</mat-label>
                                                            <input matInput formControlName="fechaCobertura" [matDatepicker]="picker2">
                                                            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker2></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Fecha de Baja</mat-label>
                                                            <input matInput formControlName="fechaBaja" [matDatepicker]="picker3">
                                                            <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker3></mat-datepicker>
                                                            <mat-error *ngIf="fechaNoValida">Ingrese una fecha</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- SECCIÓN CONDICIONES ESPECIALES -->
                                            <div class="form-section">
                                                <h4 class="section-title">Condiciones Especiales</h4>
                                                <div class="form-row">
                                                    <div class="form-field toggle-field">
                                                        <div class="toggle-container">
                                                            <mat-label class="toggle-label">PMI</mat-label>
                                                            <mat-slide-toggle formControlName="pmi"
                                                                            color="primary">
                                                                {{formAfiliado.get('pmi').value ? 'Si' : 'No'}}
                                                            </mat-slide-toggle>
                                                        </div>
                                                    </div>

                                                    <div class="form-field toggle-field">
                                                        <div class="toggle-container">
                                                            <mat-label class="toggle-label">Discapacidad</mat-label>
                                                            <mat-slide-toggle formControlName="discapacidad"
                                                                            color="primary">
                                                                {{formAfiliado.get('discapacidad').value ? 'Si' : 'No'}}
                                                            </mat-slide-toggle>
                                                        </div>
                                                    </div>

                                                    <div class="form-field toggle-field">
                                                        <div class="toggle-container">
                                                            <mat-label class="toggle-label">Otras Cronicidades</mat-label>
                                                            <mat-slide-toggle formControlName="otrasCronicidades"
                                                                            color="primary">
                                                                {{formAfiliado.get('otrasCronicidades').value ? 'Si' : 'No'}}
                                                            </mat-slide-toggle>
                                                        </div>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Patologías</mat-label>
                                                            <mat-select formControlName="patologias" multiple>
                                                                <mat-option *ngFor="let patologia of patologiasDisponibles" [value]="patologia">
                                                                    {{ patologia }}
                                                                </mat-option>
                                                            </mat-select>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- SECCIÓN VENCIMIENTOS -->
                                            <div class="form-section">
                                                <h4 class="section-title">Vencimientos</h4>
                                                <div class="form-row">
                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Vencimiento PMI</mat-label>
                                                            <input matInput formControlName="fechaVtoPMI" [matDatepicker]="picker4">
                                                            <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker4></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Vencimiento Discapacidad</mat-label>
                                                            <input matInput formControlName="fechaVtoDiscapacidad" [matDatepicker]="picker5">
                                                            <mat-datepicker-toggle matSuffix [for]="picker5"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker5></mat-datepicker>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="form-field">
                                                        <mat-form-field appearance="outline" class="full-width">
                                                            <mat-label>Vencimiento Otras Cronicidades</mat-label>
                                                            <input matInput formControlName="fechaVtoOtrasCronicidades" [matDatepicker]="picker6">
                                                            <mat-datepicker-toggle matSuffix [for]="picker6"></mat-datepicker-toggle>
                                                            <mat-datepicker #picker6></mat-datepicker>
                                                            <mat-error *ngIf="fechaNoValidaCronicidades">Ingrese una fecha de discapacidad</mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-actions">
                                            <div *ngIf="!formAfiliado.valid" style="color: #d32f2f; font-size: 12px; margin-bottom: 10px; font-weight: bold;">
                                                Faltan campos: 
                                                <span *ngIf="formAfiliado.get('nombre').invalid">Nombre, </span>
                                                <span *ngIf="formAfiliado.get('apellido').invalid">Apellido, </span>
                                                <span *ngIf="formAfiliado.get('tipoIdentificacion').invalid">Tipo ID, </span>
                                                <span *ngIf="formAfiliado.get('identificacion').invalid">ID, </span>
                                                <span *ngIf="formAfiliado.get('signoSedes').invalid">Sede, </span>
                                                <span *ngIf="formAfiliado.get('signoPlan').invalid">Plan, </span>
                                                <span *ngIf="formAfiliado.get('birth').invalid">Fecha Nac., </span>
                                            </div>
                                            <button routerLink="/afiliados-listado" class="btn-cancelar">CANCELAR</button>
                                            <button [disabled]="!formAfiliado.valid"
                                                    [ngClass]="{'custom-disabled': !formAfiliado.valid}"
                                                    type="submit" class="btn-guardar">GUARDAR</button>
                                        </div>
                                    </form>
                                </div>

                                <!-- PESTAÑA TRÁMITES -->
                                <div class="tab-pane" *ngIf="tabActiva === 'tramites'">
                                    <!-- CONTENIDO ACTUAL DE TRÁMITES -->
                                    <div class="card-header" style="background-color: #702c44;">
                                        <h3 class="text-center text-white">Solicitudes Generadas</h3>
                                    </div>                                  
                                
                                    <app-loading *ngIf="!solicitudesDataSource?.data"></app-loading>
                                
                                    <ng-container *ngIf="solicitudesDataSource?.data.length > 0; else noSolicitudes">
                                        <div *ngIf="loadingSolicitud" class="loading-overlay-solicitud">
                                            <mat-progress-spinner mode="indeterminate" diameter="30"></mat-progress-spinner>
                                        </div>
                                
                                        <table mat-table [dataSource]="solicitudesDataSource" class="w-100 mat-elevation-z2"
                                            *ngIf="solicitudesDataSource.data.length">
                                
                                            <ng-container matColumnDef="nro solicitud">
                                                <th mat-header-cell *matHeaderCellDef> N° Solicitud </th>
                                                <td mat-cell *matCellDef="let s"> {{ s._nro || 'N/A' }} </td>
                                            </ng-container>
                                
                                            <ng-container matColumnDef="fecha">
                                                <th mat-header-cell *matHeaderCellDef> Fecha </th>
                                                <td mat-cell *matCellDef="let s"> {{ s.createdAt | date:'dd/MM/yyyy' }} </td>
                                            </ng-container>
                                
                                            <ng-container matColumnDef="estado">
                                                <th mat-header-cell *matHeaderCellDef> Estado </th>
                                                <td mat-cell *matCellDef="let s"> {{ s.lastState?.state || 'Sin estado asignado'}} </td>
                                            </ng-container>
                                           
                                            <ng-container matColumnDef="acciones">
                                                <th mat-header-cell *matHeaderCellDef> Acciones </th>
                                                <td mat-cell *matCellDef="let solicitud">
                                                    <button mat-icon-button color="primary" aria-label="Ver solicitud" (click)="verSolicitud(solicitud)">
                                                        <mat-icon>visibility</mat-icon>
                                                    </button>
                                                </td>
                                            </ng-container>
                                
                                            <tr mat-header-row *matHeaderRowDef="displayedColumnsSolicitudes"></tr>
                                            <tr mat-row *matRowDef="let row; columns: displayedColumnsSolicitudes;"></tr>
                                        </table>
                                
                                        <mat-paginator #soliPaginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons
                                            aria-label="Selector de páginas">
                                        </mat-paginator>
                                    </ng-container>
                                
                                    <ng-template #noSolicitudes>
                                        <div class="alert alert-info mt-3" role="alert">
                                            <strong>Info:</strong> No se encontraron solicitudes generadas para esta persona.
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Loading Spinner -->
    <div *ngIf="loading" class="loading-overlay">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
</div>

<app-spinner
        [show]="isLoading"
        [text]="'Cargando datos del afiliado'"
        [type]="'fullscreen'"
        [color]="'#B1476A'" [trackColor]="'#4CA7C8'"
        [blurBackground]="true">
</app-spinner>